import React from 'react';
import ReactDOM from 'react-dom/client'; // Keep this for createRoot
import App from './App.jsx';
import './index.css';

const rootElement = document.getElementById('root');

// Check if the root element already has content (from prerendering)
if (rootElement.hasChildNodes()) {
  // Use hydrateRoot for React 18+ to attach to existing HTML
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  // If no existing content, render the app normally (for client-side first load)
  // This might happen if a bot doesn't get the prerendered page or for development
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}